import { render, staticRenderFns } from "./filesdatavideo.vue?vue&type=template&id=ec7c9af2&"
import script from "./filesdatavideo.vue?vue&type=script&lang=js&"
export * from "./filesdatavideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports